import _defineProperty from "/home/circleci/project/website/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { curry } from 'lodash/fp';
/**
 * Toggles value stored at given key in state
 *
 * @param {string} key - key with a value to be toggled
 * @param {object} state - state with a key/value to be toggled
 *
 * @returns {object} result - modified state
 *
 * @example
 * toggle('disable', state)
 *
 * const toggleShow = toggle('show')
 * toggleShow(state)
 */

export var toggle = curry(function (key, state) {
  return _defineProperty({}, key, !state[key]);
});
export default toggle;